import i18n from '@/libs/i18n'

export default [
  { id: 'CATEGORY', title: i18n.t('category') },
  { id: 'SUB_CATEGORY', title: i18n.t('Sub-Category') },
  { id: 'ATTRIBUTE', title: i18n.t('prodAttr') },
  { id: 'SUB_ATTRIBUTE', title: i18n.t('prodSubAttr') },
]